import { Button, Center, Stack, Text } from "@mantine/core";

type Props = {
  error: unknown;
  resetError: () => void;
};

export function SentryErrorFallback({ error, resetError }: Props) {
  const message = error instanceof Error ? error.message : String(error);
  return (
    <Center mih="100vh" p="md">
      <Stack align="center" gap="md" maw={420}>
        <Text fw={600}>Something went wrong</Text>
        <Text size="sm" c="dimmed" ta="center">
          {message}
        </Text>
        <Button onClick={resetError}>Try again</Button>
      </Stack>
    </Center>
  );
}
